<template>
  <div class="related-to-page">
    <ul>
      <li :class="{ active: isActive('/ancestry/overview') }"><router-link to="/ancestry/overview">Overview</router-link></li>
      <li :class="{ active: isActive('/ancestry/recent') }"><router-link to="/ancestry/recent">Map</router-link></li>
      <li :class="{ active: isActive('/ancestry/versions') }"><router-link to="/ancestry/versions">Versions</router-link></li>
      <li v-if="buildVersion !== 'dnanalysis'" :class="{ active: isActive('/ancestry/book-pdf') }"><router-link to="/ancestry/book-pdf">Book</router-link></li>
    </ul>
  </div>
</template>
<script>
import store from "@/store";
export default {
  name: 'RecentAncestryNavigation',
  setup(){
    const buildVersion = store.getters.profile.chipType?.type;
    return { buildVersion };
  },
  computed: {
    // Access the current route
    currentRoute() {
      return this.$route.path;
    },
  },
  methods: {
    // Determine if the route matches the current path
    isActive(path) {
      return this.currentRoute === path;
    },
  },
};
</script>